import { render, staticRenderFns } from "./OneStepUpArchive.vue?vue&type=template&id=a3f1d83e&"
import script from "./OneStepUpArchive.vue?vue&type=script&lang=js&"
export * from "./OneStepUpArchive.vue?vue&type=script&lang=js&"
import style0 from "./OneStepUpArchive.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports